<template>
  <div class="page">
    <!-- <p class="tttt">当前哈希长度：{{ hashLength }}</p>
    <p class="tttt">当前哈希值：{{ currentHash }}</p> -->
    <!-- 页面内容 -->
    <div class="container">
      <high-end-check ref="checkView" />
      <component
       :is="comp"
       v-for="comp in compList"
       :key="comp"
       :element-data="pageData"
        :merge-data="mergeData"
        :fund-code="fundCode"
        :index-info="indexInfo"
        :productSeatsInfo="productSeatsInfo" />
    </div>

  </div>
</template>

<script>
import PAGE_CONFIG from '@/configs/page-config';
import highEndIndexInfoModel from '../../model/high-end-index-info.model';
import { getProductSeatsInfo } from './components/fundApi';
import HighEndCheck from './components/HighEndCheck.vue';
import HighEndFixBottomBtn from './components/HighEndFixBottomBtn.vue';
import HighEndHeader from './components/HighEndHeader.vue';
import HighEndInfoContent from './components/HighEndInfoContent.vue';
import HighEndInfoTab from './components/HighEndInfoTab.vue';
import HighEndPreferredProduct from './components/HighEndPreferredProduct.vue';

export default {

  name: 'high-end-fund-detail',

  components: {
    HighEndHeader,
    HighEndPreferredProduct,
    HighEndInfoTab,
    HighEndInfoContent,
    HighEndFixBottomBtn,
    HighEndCheck,
  },

  props: {
    fundCode: {
      type: String,
      default: () => '',
    },
  },

  data() {
    return {
      fundName: '', // 基金名称
      pageData: {},
      mergeData: {}, // 聚合接口数据

      productSeatsInfo: {}, // 产品席位信息
      fundConfigData: {}, // 品种页配置信息
      indexInfo: {}, // 指数相关信息
      productAlternateInfo: {},
      currentHash: window.location.hash, // 当前哈希值
      hashLength: window.location.hash.length, // 当前哈希长度
    };
  },

  computed: {
    compList() {
      return PAGE_CONFIG?.highEnd || [];
    },
  },
  created() {
    this.getUserINFo(window.location.hash);
  },
  mounted() {
    this.$wxSendTrack('wxgdpzy.ym.ympg.show', 'Show', { infoCode: this.fundCode, infoCodeType: 5 });
    this.getCoreData();
    this.getHighEndMergeData();
    this.getProductSeatsInfo();
    // 监听哈希变化
    window.addEventListener('hashchange', this.updateHash);
    // setTimeout(() => {
    //   this.setLongHash();
    // }, 500);
  },

  beforeDestroy() {
    // 组件销毁时移除事件监听
    window.removeEventListener('hashchange', this.updateHash);
  },
  methods: {
    // 更新哈希值
    async updateHash() {
      this.currentHash = window.location.hash;
      this.hashLength = window.location.hash.length;
      console.log('哈希值变化为：', this.currentHash);
      this.getUserINFo(this.currentHash);
    },
    getUserINFo(currentHash) {
      if (currentHash) {
        const queryString = currentHash.slice(1);
        const params = new URLSearchParams(queryString);
        const json = {};
        // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of params.entries()) {
          json[key] = value;
        }
        window.highEndInfo = json;
        console.log('获取到的用户信息：', json);
        setTimeout(() => {
          this.$refs.checkView.initCheck();
        }, 500);
      }
    },
    setLongHash() {
      const json = {
        deviceid: '11909F7F-679C-45B7-BEA8-79DF786DBD84',
        uid: '313e8dc038fd4833910785c70729250e',
        devicetoken: '',
        passportutokentrue: 'QjaJ8B6U43EzrU9QuBKxUbHjMhnn1COyX7PCCYYtMa-z2O5JM9f3CA5UVZKJ52LxiA5UulppxXHdwjZSaQro4UjnAbEXXNB-s0SxSqg36rHjan-qeGj29ll-HVa25tg2vLMYbR7tVJzkIdI3qQ3qVQysUsQqH4LyzHBaFOpWZf2Fz-nx_yRjnhQ4E7dqQg4Fn71Ya1iwiQtqI-b8Q9YqlaUjYFuzXjzsGeoHdNB-qytMpV9B7_OUWbkD_dxE0o_vgTEJM3kXu0eKn-vT9IPq7Z9nDPYYyWiLg438LzGmYPsy1gW_pMkMPWRIi_BoVUEZ-MsSmhYZcI8',
        devicetype: 'IOS15.2.0',
        passportctokentrue: 'X10eh136y9xYZ-D6SWiGD5PWwu3M7TJr3HMvtsaT3Nnk3VEfzbU4m6-Du8j4309A7aHZhEKWkKF2UeQjp6IWxgaYgjBQu_y1OT8T4kwXkr-b_LxSfY4XC02tCxAAJBI6z6vgtiTZ7Vt0QO5UxxF0fXRcZWSG5haV2uJ04aTZJvE',
        plat: 'Iphone',
        pi: '74360940713756740024e364b64364e6c537463334844397543707374555743507256415557496d3039344f62463951787a476a573378637150764a717250484374504c744b54425059666b6e6b6568674b74746e6957506f4a345a38376a7567334534387179766e453279364c58574d4d4a4b453d',
        hybridzone: '4',
        isvisitor: '0',
        passportid: '7436094071375674',
        nickname: '爽快得果果',
        appv: '6.7.2',
        serverversion: '6.7.2',
        utoken: 'NP1sIgu6ZkgKCwKoI3wu0vTS-BMGkiTXw6Av_HrZdc6H2hpsF1bxCnD8pjOJ_LVIvgVoxu-GAN8OIG5OmvEC_p62_0ZT8nhj5zjaNABhk2-CPAl9iMtdF_0OWmDKTyjRRl7qMr3wuS0bx0rWn_En66c1f7xJ8xMdpFO4bxxaPRw.4',
        product: 'EFund',
        shownavbar: '0',
        app: 'ttjj',
        platid: '1',
        mobilephone: '183****2338',
        loginstatus: '1',
        euid: '11909F7F-679C-45B7-BEA8-79DF786DBD84',
        osv: '15.2',
        homeloginstatus: '2',
        gtoken: 'C90BA2E3D7704B88B4082FF6D7580559',
        isbindingpassportid: '1',
        os: 'iOS',
        fromplat: '1',
        oldpassportid: '',
        devicemobile: 'Simulator',
        zone: '4',
        passportctoken: 'ikDjn75MZzio8YB3jopmcDw0KtCnDp5IhlJLPMJ4DkM1Y8ofk7yLxSmMVxe8LgxEZfpw0jeCpL_Orug7K2vVOV5FNkpIGBtFm5HWVV8Q3-y7OFMWmsOTGOJ0hlWUIgX7t_55Cn8qT879_yq4zOOZcJgSeXqGNyutyq3U3-Ey-m07kwx2OneHrjs1KSg5dhWbQdaTuKj0e1P2qL6XlhUZZqX5bvP8ZiOR3bC0Ev4QASE.4',
        v: '6.7.2',
        uniqueid: '177a31909F7F-679C-45B7-BEA8-79DF786DBD8a8904',
        ctoken: 'ikDjn75MZzio8YB3jopmcDw0KtCnDp5IhlJLPMJ4DkM1Y8ofk7yLxSmMVxe8LgxEZfpw0jeCpL_Orug7K2vVOV5FNkpIGBtFm5HWVV8Q3-y7OFMWmsOTGOJ0hlWUIgX7t_55Cn8qT879_yq4zOOZcJgSeXqGNyutyq3U3-Ey-m07kwx2OneHrjs1KSg5dhWbQdaTuKj0e1P2qL6XlhUZZqX5bvP8ZiOR3bC0Ev4QASE.4',
        passportIntroduce: '',
        usefingerprint: '0',
        passportutoken: 'NP1sIgu6ZkgKCwKoI3wu0vTS-BMGkiTXw6Av_HrZdc6H2hpsF1bxCnD8pjOJ_LVIvgVoxu-GAN8OIG5OmvEC_p62_0ZT8nhj5zjaNABhk2-CPAl9iMtdF_0OWmDKTyjRRl7qMr3wuS0bx0rWn_En66c1f7xJ8xMdpFO4bxxaPRw.4',
        apptype: 'ttjj',
        customername: '周晓宇',
        isapp: '1',
      };
      const params = new URLSearchParams(json);

      // 获取查询字符串
      const queryString = params.toString();
      const longHash = `#${queryString}`; // 生成一个100万字符的哈希值
      window.location.hash = longHash;
    },
    async getCoreData() {
      const res = await this.$http.useRequests('FundComApi.getHighEndCoreData', this.fundCode);
      console.log('getCoreData', res);
      this.pageData = res;
    },

    async getProductSeatsInfo() {
      const { fundCode } = this;
      const res = await getProductSeatsInfo({ productParamList: [{ fundCode }] });
      this.productSeatsInfo = res?.data?.Data?.productInfoList?.[0] || {};
    },

    async getHighEndMergeData() {
      try {
        const res = await this.$http.useRequests('FundDgs.getHighEndMergeData', this.fundCode);
        console.log('getHighEndMergeData', res);
        this.mergeData = res;
        this.getHighEndIndexData(res);
      } catch (error) {
        console.error('getHighEndMergeData', error);
      }
    },

    async getHighEndIndexData(params) {
      const { benchMark, nSmallType } = params || {};
      const res = await this.$http.useRequests('FundComApi.getFundIndexDiyData', `${benchMark},DCGD${nSmallType}9,DCGD${nSmallType}10`);
      this.indexInfo = highEndIndexInfoModel.objectWithKeyValues({
        data: res?.data ?? [],
        mergeData: params,
      });
      console.log('indexInfo', this.indexInfo);
    },
  },

};

</script>

<style lang="less" scoped>
.page {
  background-image: linear-gradient(#31180E 200px,#f5f5f5 400px,#f5f5f5);
  min-height: 750px;
  // background-image: url('https://j5.dfcfw.com/sc/image/202203/20220309052107.png');
  z-index: -1;
  width: 100%;
  min-height: 450px;
  box-sizing: border-box;
  .container {
    width: 100%;
    padding: 24px 24px 0;
    box-sizing: border-box;
  }
}
.tttt {
  color: #ff4400;
  font-size: 24px;
}
</style>
